import { fetchDataByTag as fetchDataByTagApi } from 'support/api/DataByTagApi';
import { HttpClient } from 'support/api/api-types';

export const LEAGUE = 'LEAGUE' as const;
export const CLEAR_LEAGUE = 'CLEAR_LEAGUE' as const;

export const fetchLeague = (tag: string) => ({
  type: LEAGUE,
  promise: (httpClient: HttpClient) => fetchDataByTagApi(httpClient, tag),
  meta: {
    id: tag,
  },
});

export const clearLeague = () => ({
  type: CLEAR_LEAGUE,
});
